import { useForm } from "react-hook-form";
import { useNavigate, useLocation, Location, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { getErrorMessage } from "../../api/client";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import { Logo } from "../../components/ui/Logo";
import { percorsoDiRitorno } from "../../utils/percorsoDiRitorno";

interface LoginForm {
  identifier: string;
  password: string;
}

export default function Login() {
  const { login } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation() as Location & { state?: { from?: Location } };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginForm>();

  const onSubmit = handleSubmit(async ({ identifier, password }) => {
    try {
      const user = await login(identifier, password);
      const redirectTo = percorsoDiRitorno(location.state?.from?.pathname);
      navigate(user.must_change_password ? "/cambio-password" : redirectTo, { replace: true });
    } catch (err) {
      showToast(getErrorMessage(err, "Accesso non riuscito. Riprova."), "error");
    }
    // Nessun setLoading manuale: react-hook-form gestisce isSubmitting e lo
    // ripristina automaticamente sia in caso di successo che di errore.
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="w-full max-w-sm rounded-card bg-white p-8 shadow-card">
        <div className="mb-8 text-center">
          <Logo className="mx-auto w-44" />
          <p className="mt-2 text-sm text-ink/50">Accedi alla piattaforma gestionale</p>
        </div>

        <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
          <Input
            label="Email o numero di telefono"
            type="text"
            autoComplete="username"
            required
            error={errors.identifier?.message}
            {...register("identifier", { required: "Inserisci email o numero di telefono." })}
          />

          <Input
            label="Password"
            type="password"
            autoComplete="current-password"
            required
            error={errors.password?.message}
            {...register("password", { required: "La password è obbligatoria." })}
          />

          <Link to="/forgot-password" className="-mt-2 self-end text-xs font-semibold text-primary hover:underline">
            Password dimenticata?
          </Link>

          <Button type="submit" loading={isSubmitting} className="mt-2 w-full">
            Accedi
          </Button>
        </form>
      </div>
    </div>
  );
}
